const getPathname = ( path: string ) => path.split( /[?#]/, 1 )[ 0 ];

export const isSideNavRouteActive = ( currentPath: string, href: string ) =>
	getPathname( currentPath ) === getPathname( href );
